import { Tag } from './SmartTagsWysiwyg';

export function useSegmentedSmartTagsChooserHelper() {
  const onTagTyped = (
    allTags: Tag[],
    searchTerm: string,
    renderListFunc: any,
    disableSegmentMode = false,
  ) => {
    const currentSegment = searchTerm.includes('.')
      ? searchTerm.split('.')
        .slice(0, -1)
        .join('.')
      : '';

    const currentSegmentPrefix = currentSegment !== '' ? `${currentSegment}.` : '';

    const currentSegmentTags = currentSegment !== '' ? allTags
        .filter((tag: Tag) => tag.value.startsWith(currentSegmentPrefix))
      : allTags;

    const isChooseSegmentMode = () => {
      if (disableSegmentMode) {
        return false;
      } else {
        if (currentSegment.length === 0) {
          return true;
        } else {
          return !currentSegmentTags
            .find(
              (tag: Tag) => !tag.value.replace(currentSegmentPrefix, '')
                .includes('.')
            );
        }
      }
    };

    let values: Tag[];

    if (isChooseSegmentMode()) {
      values = (Array
        .from(
          new Set(
            currentSegmentTags
              .map((tag: Tag) => ({
                ...tag,
                id: `segment:${tag.value}`,
                value: currentSegment !== '' ? tag.value.replace(currentSegmentPrefix, '') : tag.value,
              }))
              .map((tag: Tag) => tag.value.split('.')[0])
          )
        ) as string[])
        .map((tagName: string) => ({
          id: `segment:${tagName}`,
          value: `${currentSegmentPrefix}${tagName}`,
        })) as Tag[];
    } else {
      values = currentSegmentTags;
    }

    if (searchTerm.length === 0) {
      renderListFunc(values, searchTerm);
    } else {
      const matches = [];
      for (let i = 0; i < values.length; i += 1) {
        if (values[i].value.toLowerCase()
          .indexOf(searchTerm.toLowerCase()) !== -1) {
          matches.push(values[i]);
        }
      }
      renderListFunc(matches, searchTerm);
    }
  };

  const onTagSelected = (
    tag: Tag,
    insertItemFunc: (item: Tag) => void,
    parteTextFunc: (item: Tag) => void
  ) => {
    if (tag.id.startsWith('segment:')) {
      parteTextFunc(tag);
    } else {
      insertItemFunc(tag);
    }
  };

  return {
    onTagTyped,
    onTagSelected,
  };
}
